import createSpacing from '@material-ui/core/styles/createSpacing';
/**
 * Custom spacing configuration for AgentNet. To be extended by each brand where needed.
 */
export const spacing = createSpacing(8);
